export const Abstract01Icon = () => {
  return (
    <svg
      width="130"
      height="125"
      viewBox="0 0 130 125"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M127.756 46.474H91.5194L98.7765 24.1392C99.2068 22.8142 97.6905 21.7127 96.564 22.5316L77.5645 36.3351L66.367 1.87239C65.9368 0.547745 64.0624 0.547745 63.6318 1.87239L52.4343 36.3351L33.4351 22.5316C32.3082 21.7127 30.792 22.8142 31.2226 24.1392L38.4794 46.474H2.24348C0.850245 46.474 0.271404 48.2565 1.39826 49.0751L30.7137 70.3741L11.7145 84.1779C10.5877 84.9968 11.1668 86.7791 12.5597 86.7791H36.0442L24.8463 121.242C24.4161 122.566 25.9323 123.668 27.0595 122.849L56.375 101.55L63.6318 123.885C64.0624 125.21 65.9368 125.21 66.367 123.885L73.6241 101.55L102.94 122.849C104.066 123.668 105.583 122.566 105.152 121.242L93.9549 86.7791H117.439C118.832 86.7791 119.411 84.9968 118.284 84.1779L99.2854 70.3741L128.601 49.0751C129.728 48.2565 129.149 46.474 127.756 46.474Z"
        fill="url(#paint0_linear_1866_18457)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1866_18457"
          x1="64.9995"
          y1="0.878906"
          x2="64.9995"
          y2="124.879"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.08" />
        </linearGradient>
      </defs>
    </svg>
  );
};
